import React from "react";
import styled from "styled-components";
import "./BlogStyles.css";
import { useTranslation } from "react-i18next";
export default function Blog() {
  const { t } = useTranslation();

  return (
    <Wrapper id="projects" className="whiteBgs bodys">
      <div className="">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">{t("Plusdinformations")}</h1>
            <p className="font13">
              {t("Plusdinformations")} <br />
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-md-4 col-lg-4 col-md-4 col-lg-4">
              <div className="card">
                <div className="card-content">
                  <h2 className="card-title" style={{ marginTop: "33px" }}>
                    {t("partéléphone")}
                  </h2>
                  <p className="card-body">{t("avancepour")}</p>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-lg-4 col-md-4 col-lg-4">
              <div className="card2">
                <div className="card-content">
                  <h2 className="card-title" style={{ marginTop: "40px" }}>
                    {t("tarif")}
                  </h2>
                  <p className="card-body">{t("transparence")}</p>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-lg-4 col-md-4 col-lg-4">
              <div className="card3">
                <div className="card-content">
                  <h2 className="card-title " style={{ marginTop: "30px" }}>
                    {t("Meilleurschauffeurs")}
                  </h2>
                  <p className="card-body">{t("Économisez")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
  @media (max-width: 860px) {
    width: 60%;
  }
`;
const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
